export default function( string ) {
	return String( string ).toLowerCase().replace( /\W+/g, '-' ).replace( /^-?(.+)-$/, '$1' );
}
